import { Capacitor } from '@capacitor/core';

/**
 * True when the app is running inside a Capacitor native shell (iOS / Android).
 *
 * Used to hide purchase, billing and payment-configuration UI from App Store /
 * Play Store builds so we stay compliant with Apple Guideline 3.1.3(b) and
 * Google Play's B2B payments carve-out — subscription purchases are handled
 * on the web with direct Xero invoices, not through IAP.
 */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * True only inside the iOS native shell.
 *
 * Apple Guideline 3.1.1 rejects in-app sign-up for businesses/organisations
 * (it reads as a route to an external purchase). Google Play has no such rule,
 * so account and organisation creation stay available on Android and the web.
 */
export function isIOSApp(): boolean {
  return Capacitor.getPlatform() === 'ios';
}
